var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobListLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56C43.464 56 56 43.464 56 28Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0026 30.8624L25.8339 21.0316C27.1085 19.7772 27.8969 18.0171 27.8969 16.0957C27.8969 14.194 27.1286 12.4546 25.8944 11.2002L16.0636 21.0316C14.789 22.2854 14 24.0455 14 25.9674C14 27.8888 14.7689 29.6085 16.0026 30.8624ZM39.8121 25.1173L29.9807 34.9487C28.7062 36.2031 27.9171 37.9626 27.9171 39.8845C27.9171 41.7863 28.686 43.5256 29.9202 44.78L39.751 34.9487C41.0256 33.6948 41.8146 31.9348 41.8146 30.0128C41.8146 28.0915 41.0458 26.3717 39.8121 25.1173ZM39.751 21.0517C41.0256 19.7973 41.8146 18.0378 41.8146 16.1159C41.8146 14.2141 41.0458 12.4748 39.8121 11.2204L16.0636 34.9487C14.789 36.2232 14 37.9626 14 39.9047C14 41.8064 14.7689 43.5458 16.0026 44.8002L39.751 21.0517Z",
    fill: "#3D92E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobListLogo1);
export default __webpack_public_path__ + "static/media/job-list-logo-1.72f4141c63f08a9fc5cf1bc5e5d34948.svg";
export { ForwardRef as ReactComponent };